export default {"src":"/_next/static/media/data-deletion.f58ed4a3.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};